/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        window.sr = ScrollReveal().reveal('.custom-logo-link, h1, .description, .order, .register, .carousel-down, .carousel-control', { duration: 1000 }, 50);
        sr.reveal('#map-container .container, main h2, main h3, .apps, .lead, .carousel-indicators, main .btn, .quote, .gallery, .store-menu, .pdf-menu', { duration: 1000 });

        $('.banner').hide();
        $(' .top-info').hide();
        $('.banner').fadeIn(300);
        $('.top-info').fadeIn(300);

        // JavaScript to be fired on all pages, after page specific JS is fired
        $(document).on('click', '.gallery-item a', function(event) {
          event.preventDefault();
          $(this).ekkoLightbox({
            alwaysShowClose: false,
            loadingMessage: '<i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw text-muted"></i><span class="sr-only">Loading...</span>'
          });
        });

        $('#top-link-block').click(function(){
          $('html,body').animate({
            scrollTop: 0
          }, 500);
        });

        $('.navbar-collapse a:not(.dropdown-toggle)').click(function() {
          if ($(window).width() < 768) {
            $('.navbar-collapse.in').collapse('hide');
          }
        });

        $(window).bind('scroll', function(){
          var offset = $(document).scrollTop();
          var opacity = 0;

          opacity = offset / $(document).height();

          $('#top-link-block').css('opacity', opacity);
        });

        $(".banner").sticky({
          topSpacing: 0,
          zIndex: 1030
        } );

        $(".banner ul li a[href^='#']:not(.dropdown-toggle)").on('click', function(e) {

          // prevent default anchor click behavior
          e.preventDefault();

          // store hash
          var hash = this.hash;

          // animate
          $('html, body').animate({
              scrollTop: $(hash).offset().top
            }, 500, function(){

            // when done, add hash to url
            // (default click behaviour)
            window.location.hash = hash;
            });

        });

        $('.dropdown-toggle').dropdown();
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
